import React from 'react';
import { StarIcon } from 'lucide-react';
import { Logo } from '../Logo';
import { CTAButton } from '../CTAButton';
import { LOGO_URL } from '../../data/content';
export function Hero() {
  return <header className="w-full bg-[#FBF8F3] px-5 pb-12 pt-7 sm:px-6 sm:pb-16 sm:pt-10" data-id="element-164" data-mp="cvbejhngf7nv">
      <div className="mx-auto max-w-3xl" data-id="element-165" data-mp="huo2y6tz4msk">
        <Logo data-id="element-166" data-mp="hvqu8fv7kr90" />

        <h1 className="mt-8 text-center font-display text-[2.05rem] font-bold leading-[1.08] tracking-[-0.02em] text-[#0E3B42] sm:text-5xl md:text-[3.4rem]" data-id="element-167" data-mp="hw8x3vcdm3pw">
          Impara esattamente quale paziente trattare, quale GLP-1 scegliere e{' '}
          <em className="font-semibold italic text-[#17808D]" data-id="element-168" data-mp="vmm0dkebou8w">
            come titolare ogni dose
          </em>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-center text-[15.5px] leading-relaxed text-[#3F5F64] sm:text-lg" data-id="element-169" data-mp="10kdv0m6cqugs">
          Domina ogni decisione clinica —dalla selezione del paziente al
          follow-up a lungo termine— con un algoritmo pratico che elimina
          l’improvvisazione e ti aiuta a prescrivere GLP-1 con maggiore
          sicurezza in ogni visita.
        </p>

        <div className="mx-auto mt-5 flex max-w-md items-center justify-center gap-2 rounded-full bg-[#F3EDE3] px-4 py-2" data-id="element-170" data-mp="4oge9gknbigd">
          <span className="flex" aria-hidden="true" data-id="element-171" data-mp="3vvsmh63jwlk5">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-[#D79B2B] text-[#D79B2B]" data-id="element-172" data-mp="3ruqtv84537r5" />)}
          </span>
          <p className="text-[12px] font-semibold leading-tight text-[#4A6B70] sm:text-[13px]" data-id="element-173" data-mp="nfh7dnz34js0">
            Più di 1.200 medici si affidano già alla Dott.ssa Karito
          </p>
        </div>

        <figure className="mt-8 sm:mt-10" data-id="element-174" data-mp="en5kgc36jegs">
          <img src={LOGO_URL} alt="Percorso Clinico GLP-1: 6 volumi clinici e 5 bonus esclusivi in formato digitale" className="mx-auto w-full max-w-lg" width={1080} height={1080} data-id="element-175" data-mp="em46nzus4dvd" />
        </figure>

        <div className="mt-6 sm:mt-8" data-id="element-176" data-mp="30ldyt24r62mw">
          <CTAButton id="hero-cta" label="Voglio il percorso clinico GLP-1" subline="Download immediato · Pagamento unico · Accesso a vita · Garanzia di 7 giorni" data-id="element-177" data-mp="30mfh9ro3lren" />
        </div>

        <p className="mx-auto mt-6 max-w-md text-center font-display text-[17px] font-semibold italic leading-snug text-[#0E3B42] sm:text-xl" data-id="element-178" data-mp="2qu9rmolbjm2m">
          Prescrivi con la sicurezza di uno specialista, anche se oggi hai
          ancora dubbi sui GLP-1.
        </p>
      </div>
    </header>;
}